import { AxiosResponse } from 'axios'
import { FormValues } from '../store/models/employeeData.model'
import { SystemValues } from '../store/models/systemValues.model'
import axiosInstance from './api.service'
import { ComplianceTaskListModel } from '../store/models/complianceTaskListModel'

interface ISearchService {
    getISearchServiceCollection(employeeData: FormValues): Promise<ComplianceTaskListModel>,
    getSystemValues(): Promise<SystemValues>,
    getDownloadPdf(employeeData: FormValues): Promise<any>
}

const SearchService: ISearchService = {
    getISearchServiceCollection: async (employeeData: FormValues) => {
        return await axiosInstance.post('api/accreditation/training_event_2_person', {
            firstName: employeeData.firstName,
            lastName: employeeData.lastName,
            birthday: employeeData.birthday,
            phone: employeeData.phone,
            email: employeeData.email,
            logonID: employeeData.logonID
        }).then(
            (res: AxiosResponse) => res.data
        ).catch((ex: any) => console.log(ex.message))
        // return await axiosInstance.post('api/accreditation/training_event_2_person', employeeData, {
        //     headers: {
        //         'Content-Type': 'application/json'
        //     }
        // }).then(
        //     (res) => res.data
        // ).catch((ex) => console.log(ex.message));
    },

    getSystemValues: async () => {
        return await axiosInstance.get('api/accreditation/getSystemValues').then((res: AxiosResponse) => res.data).catch((ex: any) => console.log(ex.message))
    },
    getDownloadPdf: (employeeData: FormValues) => {
        return axiosInstance.post('api/accreditation/getDownloadPdf', {
            firstName: employeeData.firstName,
            lastName: employeeData.lastName,
            birthday: employeeData.birthday,
            phone: employeeData.phone,
            email: employeeData.email,
            logonID: employeeData.logonID
        }, {
            responseType: 'blob'
        }).then((res: any) => res.data).catch((ex: any) => console.log(ex.message))
    }
}

export default SearchService